import { atom, getDefaultStore } from "jotai";
import { WorkshopItem } from "./types/workshopItem";

const store = getDefaultStore();
export const workshopItemsAtom = atom<WorkshopItem[]>([]);

const get = () => store.get(workshopItemsAtom);

const set = (items: WorkshopItem[]) => store.set(workshopItemsAtom, items);

const add = (item: WorkshopItem) => store.set(workshopItemsAtom, [...store.get(workshopItemsAtom), item]);

const update = (updatedItem: WorkshopItem) =>
{
	const items = store.get(workshopItemsAtom);
	store.set(workshopItemsAtom, items.map(i => i.publishedFileId === updatedItem.publishedFileId ? updatedItem : i));
};

const remove = (publishedFileId: string) =>
{
	store.set(workshopItemsAtom, store.get(workshopItemsAtom).filter(i => i.publishedFileId !== publishedFileId));
};

const clear = () => store.set(workshopItemsAtom, []);

export const workshopStore = {
	get,
	set,
	add,
	update,
	remove,
	clear,
};
